import React, { useEffect } from 'react';
import { useRoute, Link } from 'wouter';

import ChevronRightSvg from '../../common/ChevronRightSvg';

export const ActiveLink = (props) => {
    const [isActive] = useRoute(props.href);
    return (
        <Link {...props} asChild>
            <a className={isActive ? props.className + ' active' : props.className}>
                <span>{props.children}</span>
                <ChevronRightSvg />
            </a>
        </Link>
    );
};
export default ActiveLink;
